var exports = {};

function expoIn(t) {
  return t === 0 ? t : Math.pow(2, 10 * (t - 1));
}

exports = expoIn;
export default exports;